import "./ExpertiseLayout.scss"

export default function ExpertiseLayout({ divisions }) {
  return (
    <div className="menu-grid expertise">
      {divisions.map((division) => (
        <div className="menu-column" key={division.code}>
          <a href={division.href} className="menu-title">
            {division.code} Division
          </a>
          <p className="menu-subtitle">{division.title}</p>
          <ul className="menu-list">
            {division.services.map((service, idx) => (
              <li key={idx}>
                <a href={service.href} className="menu-link">
                  {service.text}
                </a>
              </li>
            ))}
          </ul>
          <a href={division.view_all.href} className="view-all">
            {division.view_all.text}
          </a>
        </div>
      ))}
    </div>
  );
}
